import { DeepReadonly, IApplyUniConfig } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export enum DefaultDashboardTabIds {
  LEADS = 'Leads',
  APPLIED = 'Applied',
  DRAFT_OFFERS = 'Draft',
  CONDITIONAL = 'Conditional',
  UNCONDITIONAL = 'Unconditional',
  COMPLETED = 'Completed',
  CLOSED = 'Closed'
}

const applyUniConfig: IApplyUniConfig = {
  // TODO: Where and how do we define which variables are avaliable to these "templates"?
  offerLetterStartTemplate: `We are delighted to issue you a {conditionType} offer to study {courseName} starting {intakeIdLabel}.`,
  offerLetterEndTemplate: `Admissions Team`,
  scholarships: [],
  termsAndConditionsUrl: 'https://www.enroly.com',
  privacyPolicyUrl: 'https://www.enroly.com',
  privacyPolicyConsentWording: {
    subtitle: 'Our privacy policy and how it affects you',
    header:
      'I consent to the processing of sensitive data (e.g., health, ethnicity) to support my application and for monitoring purposes',
    buttonLabel: 'Privacy policy',
    bodyText:
      'The information provided will be used to assess your eligibility and progress your application, in accordance with the {universityName} {privacyPolicyUrl}'
  },
  termsAndConditionConsentWording: {
    subtitle: "Read and consent to the University's terms and conditions",
    header: 'Terms & conditions',
    buttonLabel: 'Terms & conditions',
    bodyText: 'I consent to the {universityName}'
  }
};

export const defaultApplyUniConfig: DeepReadonly<IApplyUniConfig> = deepFreeze(applyUniConfig);
